import { render, staticRenderFns } from "./AboutCommitteesIndexMore.vue?vue&type=template&id=0de6a51f&"
import script from "./AboutCommitteesIndexMore.vue?vue&type=script&lang=js&"
export * from "./AboutCommitteesIndexMore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports